import React, { useRef } from "react"
import { useReadMoreButton } from "../../hooks"

import StrapiMedia from "../strapi-media"

const SectionInfo = ({ data }) => {
  const sectionInfo = useRef(null)

  useReadMoreButton(sectionInfo, "Read More", "Read Less")

  if (!data) return <div></div>
  const {
    reverse,
    image,
    info,
    imageClass,
    contentClass,
    borderBottom,
    isAlignStart,
    backgroundColor,
  } = data?.attributes

  return (
    <section
      className="w-full mx-auto lg:pt-[125px] pt-10 2xl:px-0"
      ref={sectionInfo}
    >
      <div
        style={{ backgroundColor: backgroundColor }}
        className={`w-full mx-auto justify-between  ${
          isAlignStart ? "flex items-start" : "flex items-center"
        } flex-col ${reverse ? "lg:flex-row-reverse" : "lg:flex-row"}`}
      >
        <div
          className={`block ${
            imageClass ? imageClass : `block lg:w-5/12 w-full`
          }`}
        >
          <StrapiMedia image={image} className="w-full" />
        </div>
        <div
          className={`${
            contentClass
              ? contentClass
              : "mt-20 lg:mt-0 lg:w-1/2 inline-block w-full"
          }`}
          dangerouslySetInnerHTML={{ __html: info }}
        ></div>
      </div>
      <div className="mt-20 lg:mt-[125px]"></div>
      {borderBottom ? (
        <div className="max-w-screen-reds-2xl m-auto px-7">
          <div className="w-full border-b"></div>
        </div>
      ) : (
        <div className="mt-20"></div>
      )}
    </section>
  )
}

export default SectionInfo
